import React, { Fragment, useState, useEffect } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import formatCurrency from 'format-currency';
import '../../static/less/new_shopping_cart/new_loyalty_card.css';
import cardImageBlue from '../../static/images/Blue.png';
import cardImageGold from '../../static/images/Gold.png';
import increaseCoinsImage from '../../static/images/IncreaseCoins.png';
import decreaseCoinsImage from '../../static/images/DecreaseCoins.png';
import cardImagePlatinum from '../../static/images/Platinum.png';
import cardImageBlack from '../../static/images/Black.png';
import cardImageSilver from '../../static/images/Silver.png';
import cardImageSABlue from '../../static/images/SABlue.png';
import cardImageSAGold from '../../static/images/SAGold.png';
import cardImageSASilver from '../../static/images/SASilver.png';
import { setCoinsApplied } from '../../actions/Loyalty';
import { IconComponent } from '../ds/atoms/icons/iconComponent';
import { CALL_CENTER_ROLE } from '../../constants';
import {
  incrementCoins, decrementCoins, validateSetCoinsManually,
  getUpperLimit,
} from '../booking/utils';
import {
  convertCoinsToCurrency, showLoyaltyClaimPopup,
  convertCoinsToCurrencyUsingRoundedConversionRate,
} from '../../utils';

const loyaltyLevelCardImages = {
  Blue: cardImageBlue,
  Gold: cardImageGold,
  Platinum: cardImagePlatinum,
  Black: cardImageBlack,
  Silver: cardImageSilver,
  'Blue Agent': cardImageSABlue,
  'Gold Agent': cardImageSAGold,
  'Silver Agent': cardImageSASilver,
};

const LevelCard = ({ membershipName }) => (
  <div className="level-card">
    <img src={loyaltyLevelCardImages[membershipName]} alt="Level Card" className="card-image" />
  </div>
);

const Coins = ({
  props,
  coins, setCoinsManually, shouldShowControls, context,
  shouldShowTitle,
}) => {
  /*const roomData = props.multipleRoomSelection;
  if(roomData['1']==null) {
    return null;
  }*/

  const [inputValue, setInputValue] = useState(props.coinsApplied);

  // Sincronizar el valor del input con el valor de monedas del estado global
  React.useEffect(() => {
    setInputValue(coins);
  }, [coins]);

  // Manejar cambios en el input
  const handleInputChange = (event) => {
    const newValue = Number(event.target.value);
    if (!Number.isNaN(newValue) && newValue >= 0) {
      setInputValue(newValue);
    }
  };

  // Actualizar el valor global y el estado local cuando se presiona Enter
  const handleKeyDown = (event) => {
    if (event.key === 'Enter') {
      handleApplyChange();
    }
  };

  // Actualizar el valor global y el estado local cuando el input pierde el foco
  const handleBlur = () => {
    handleApplyChange();
  };

  // Función para actualizar el valor global
  const handleApplyChange = () => {
    // Actualiza el estado global
    const newValue = validateSetCoinsManually(props, inputValue);
    // Actualiza el estado global y el estado local
    setInputValue(newValue);
    setCoinsManually(newValue);
  };

  const handleDecrementChange = () => {
    // Actualiza el estado global
    const newValue = validateSetCoinsManually(props, inputValue - 1);
    // Actualiza el estado global y el estado local
    setInputValue(newValue);
    setCoinsManually(newValue);
  };

  const handleIncrementChange = () => {
    // Actualiza el estado global
    const newValue = validateSetCoinsManually(props, inputValue + 1);
    // Actualiza el estado global y el estado local
    setInputValue(newValue);
    setCoinsManually(newValue);
  };

  const applyAllCoins = () => {
    // Actualiza el estado global
    const newValue = validateSetCoinsManually(props, props.memberInfo.availableCoins);
    // Actualiza el estado global y el estado local
    setInputValue(newValue);
    setCoinsManually(newValue);
  };

  const getFractionDigits = () => {
    //Pidieron que quieren ver los costos redondeados cuando la moneda no sea la de la reserva
    const fractionDigits = {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    };
    return fractionDigits;
  };

  const fractionDigits = getFractionDigits();
  const finalCoinsApplied = (props.isEditingBooking || props.isInBookingDetailsPage === true)
    ? props.coinsUsedInEditingBooking : props.coinsApplied;

  return (
    <div className="coins">
      { shouldShowTitle === true
        && <h2>{context.t('Use Coins')}</h2>
      }
      <div className="coin-controls">
        {shouldShowControls && <button style={{ fontSize: '25px' }}
          onClick={handleDecrementChange}><img src={decreaseCoinsImage}
          alt="Decrease" className="increaseDecreaseImage" /></button>}
        <div className="currency-input-container">
          <span className="currency-symbol">$</span>
          <input
            type="number"
            value={inputValue}
            /*value={Math.round(convertCoinsToCurrency(inputValue) * 100) / 100}*/
            onChange={handleInputChange}
            onBlur={handleBlur}
            onKeyDown={handleKeyDown}
            className={'coinsInputManually'}
          />
        </div>
        {shouldShowControls
        && <button onClick={handleIncrementChange}>
            <img src={increaseCoinsImage} alt="Increase" className="increaseDecreaseImage" />
           </button>}
      </div>
      {props.memberInfo.availableCoins > 0
      && <div className='coinsInfo'>
        <p className='available-coins-text'>{`1 ${context.t('coin')} = ${formatCurrency(convertCoinsToCurrency(1), props.currency)}`}</p>
        {/*<p className="available-coins-text">{context.t('Available Coins')}: { props.memberInfo ? props.memberInfo.availableCoins : 0}</p>*/}
        {<p className="subtotal-price">-{formatCurrency(
          Math.round(
            convertCoinsToCurrencyUsingRoundedConversionRate(finalCoinsApplied) * 100) / 100,
          {
            ...props.currency,
            minimumFractionDigits: fractionDigits.minimumFractionDigits,
            maximumFractionDigits: fractionDigits.maximumFractionDigits,
          })}
                              </p>}
        <p className="apply-all-coins-text"><a className='apply-all-coins-text-link' onClick={applyAllCoins}>{context.t('Apply All')}</a></p>
        </div>
      }
    </div>
  );
};

const CouldUseYourCoins = ({
  context, props, show,
}) => {
  if (show === false) {
    return null;
  }
  return (
    <div className="couldUseYourCoins">
      {props.new_member === true
      && props.new_member_discount_percentage_activated === true
      && (props.memberInfo ? props.memberInfo.availableCoins : 0) > 0
      && <p>{context.t('You have a {discount_percentage}% discount from the total cost of the booking. Currently you have {coins} coins, so you can use up to {upperLimit} if you wish becasue according to your loyalty level you can only have up to a {maxPercentUsage}% from the total cost of the booking', {
        discount_percentage: props.new_member_discount_percentage,
        coins: props.memberInfo
          ? props.memberInfo.availableCoins : 0,
        upperLimit: getUpperLimit(props),
        maxPercentUsage: props.maxPercentUsage,
      })}</p>}
    </div>
  );
};

const ProgressBar = ({
  currentLevel,
  nextLevel,
  props,
  context,
}) => {
  // Determinar el nombre de clase y el color según el membershipName
  let color = '#2E608F';
  let className = 'loyaltyCard-progressBlue';
  if (props.membershipName.toLowerCase().includes('blue')) {
    className = 'loyaltyCard-progressBlue';
    color = '#2E608F';
  } else if (props.membershipName.toLowerCase().includes('gold')) {
    className = 'loyaltyCard-progressGold';
    color = '#F4A60B';
  } else if (props.membershipName.toLowerCase().includes('silver')) {
    className = 'loyaltyCard-progressSilver';
    color = '#c0c0c0 ';
  } else if (props.membershipName.toLowerCase().includes('platinum')) {
    className = 'loyaltyCard-progressSilver';
    color = '#c0c0c0 ';
  } else if (props.membershipName.toLowerCase().includes('black')) {
    className = 'loyaltyCard-progressBlack';
    color = '#000000ff ';
  } else {
    className = 'loyaltyCard-progressBlue'; // Clase por defecto
    color = '#2E608F';
  }

  // Calcular el porcentaje de progreso
  const progressPercentage = (props.currentNights / props.nightsNeededToUpgrade) * 100;

  // Determinar la posición del chevron
  const chevronPosition = progressPercentage > 0 ? `${progressPercentage}%` : '0%';

  return (
    <div className="loyaltyCard-progress-loyaltyCard-bar">
      <div className="loyaltyCard-levels">
        <span>{currentLevel}</span>
        <span>{nextLevel}</span>
      </div>
      <div className="loyaltyCard-bar-chevron" style={{ position: 'relative' }}>
        {/* Chevron arriba del progreso */}
        <div
          className="progress-chevron"
          style={{
            position: 'absolute',
            left: chevronPosition, // Usar la posición calculada
            transform: progressPercentage === 0 ? 'translateX(-50%)' : 'translateX(-70%)', // Centrar el chevron
            color,
            marginTop: '-10px',
          }}
        >
          <IconComponent icon={'triangle-down'} />
        </div>
      </div>
      <div className="loyaltyCard-bar">
        <div
          className={`${className}`}
          style={{ width: `${progressPercentage}%` }}
        ></div>
      </div>
      <div className="nights">
        <span>{`${props.currentNights} ${context.t('Nights')}/${props.currentStays} ${context.t('Bookings')}`}</span>
        <span className='toRight'>{`${props.nightsNeededToUpgrade} ${context.t('Nights')} (${props.agentCode !== ''
          ? context.t('in the last year') : context.t('in the last 2 years')})`}
          <br />
          {`1 ${context.t('coin')} = ${formatCurrency(convertCoinsToCurrency(1), props.currency)}`}
        </span>
      </div>
    </div>
  );
};

const NewLoyaltyCard = (props, context) => {
  const [coins, setCoins] = useState(props.coinsApplied);

  useEffect(() => {
    setCoins(props.coinsApplied);
  }, [props.coinsApplied]);

  const incrementCoinsInner = () => {
    const result = incrementCoins(props);
    if (result === true) {
      setCoins(coins + 1);
    }
  };

  const setCoinsManually = (newValue) => {
    //props.dispatch(setCoinsEntered(newValue));
    props.dispatch(
      setCoinsApplied(newValue));
    setCoins(newValue);
  };

  const decrementCoinsInner = () => {
    const result = decrementCoins(props);
    if (result === true) {
      setCoins(coins - 1);
    }
  };
  if (props.soloMostrarCoins === false) {
    return (
      <div className="loyaltyCard">
        <div className="">
          {/*}<LevelCard level="Blue" context={context}/>{*/}
          {props.shouldShowOnlyImage === true
            && <Fragment>
              <div className='row'>
                <LevelCard membershipName={props.membershipName}/>
              </div>
              <div className='row'>
                <p className='loyalty_card_your_coins_text'>{context.t('Your Coins')}</p>
              </div>
              <div className='row'>
                <p className='loyalty_card_your_coins_number'>
                  { props.memberInfo ? props.memberInfo.availableCoins : 0}
                </p>
              </div>
            </Fragment>
          }
          {(props.multipleRoomSelection['1'] != null || (props.cart.cartHotel.rooms.length > 0
           && props.mostrarExtras === true))
           && showLoyaltyClaimPopup()
           && props.shouldShowOnlyImage === false
           && <Coins
            props={props}
            coins={coins}
            setCoinsManually={setCoinsManually}
            //shouldShowControls={!(props.new_member === true && props.new_member_discount_percentage_activated === true)}
            shouldShowControls={true}
            shouldShowTitle={props.shouldShowTitle}
            context={context}
          />}
        </div>
        <ProgressBar
          currentLevel={props.membershipName}
          nextLevel={props.nextLoyaltyLevel}
          props={props}
          context={context}
        />
        {<CouldUseYourCoins
        context={context}
        props={props}
        show={false}
        />}
      </div>
    );
  }

  return (
    <Coins
      props={props}
      coins={coins}
      increment={incrementCoinsInner}
      decrement={decrementCoinsInner}
      setCoinsManually={setCoinsManually}
      //shouldShowControls={!(props.new_member === true && props.new_member_discount_percentage_activated === true)}
      shouldShowControls={true}
      shouldShowTitle={props.shouldShowTitle}
      context={context}
    />
  );
};

NewLoyaltyCard.propTypes = {
  mostrarExtras: PropTypes.bool.isRequired,
  soloMostrarCoins: PropTypes.bool.isRequired,
  shouldShowTitle: PropTypes.bool.isRequired,
  shouldShowOnlyImage: PropTypes.bool.isRequired,
};

NewLoyaltyCard.contextTypes = {
  t: PropTypes.func.isRequired,
  router: PropTypes.object.isRequired,
};

export default connect((state) => ({
  multipleRoomSelection: state.booking.multipleRoomSelection,
  cart: state.cart,
  currency: state.booking.filterCurrency,
  coinsApplied: state.loyalty.coinsApplied,
  enteredCoins: state.loyalty.coinsEntered,
  maxCoinsToApply: state.loyalty.maxCoinsToApply,
  maxPercentUsage: state.loyalty.maxPercentUsage,
  new_member: state.loyalty.newMember,
  new_member_discount_percentage: state.loyalty.newMemberDiscountPercentage,
  new_member_discount_percentage_activated: state.booking.hotel != null
    ? (state.booking.hotel.new_member_discount_percentage_activated === true
    && state.bookingFormState.agentSell === 'false') : false,
  currentStays: state.loyalty.currentStays,
  currentNights: state.loyalty.currentNights,
  membershipName: state.loyalty.selectedStatus === 'becomeMember'
    ? (state.bookingFormState.agentCode !== '' ? 'Blue Agent' : 'Blue')
    : state.loyalty.memberInfo.membershipName,
  conversionRates: state.loyalty.conversionRates,
  nightsNeededToUpgrade: state.loyalty.nightsNeededToUpgrade,
  nextLoyaltyLevel: state.loyalty.nextLoyaltyLevel,
  hotel: state.booking.hotel,
  loggedUser: state.loyalty.loggedUser,
  memberInfo: state.loyalty.memberInfo,
  distributions: state.bookingFormState.distributions.length > 0 ? state.bookingFormState.distributions
    : state.cart.cartHotel.rooms.map((room) => room.distribution),
  isEditingBooking: state.booking.isEditingBooking,
  coinsUsedInEditingBooking: state.booking.coinsUsedInEditingBooking,
  editBooking: state.booking.editBooking,
  isInBookingDetailsPage: window.location.pathname.includes('/thanks/')
    || window.location.pathname.includes('/my-booking/')
    || window.location.pathname.includes('/booking-detail/'),
  isCallCenterUser: state.session.user.role === CALL_CENTER_ROLE,
  agentCode: state.bookingFormState.agentCode,
  agentSell: state.bookingFormState.agentSell,
}))(NewLoyaltyCard);
